import { Button } from '@storeblocks/button';
import { type FC } from 'react';
import styled from 'styled-components';

import { appConfig } from '@/constants/config';
import { useTexts } from '@/hooks/useTexts';
import { TrackingElement, useGetTrackId } from '@/tracking';

import { Divider } from '../../components/Divider';
import { Column, Row } from '../../components/Grid';
import { PageHeading } from '../../components/PageHeading';
import { WithGap } from '../../components/WithGap';

export const InvitationalLinkErrorPage: FC = () => {
  const texts = useTexts();
  const getTrackId = useGetTrackId();

  return (
    <Center data-test="invitation-error-page">
      <Page>
        <PageHeading header={texts.error.description.invitation.title} />
        <Divider margin="8" />
        <StyledRow>
          <Column $span={6}>
            <StyledWithGap>
              <div className="font-body-large">
                {texts.error.description.invitation.part1}{' '}
                <a href={`mailto:${texts.error.siosEmail}`}>
                  {texts.error.siosEmail}
                </a>{' '}
                {texts.error.description.invitation.part2}
              </div>

              <Button
                as="a"
                href="/"
                iconLeft="arrow_left"
                variant="tertiary"
                data-trackid={getTrackId('go-to-connect', TrackingElement.Link)}
              >
                {texts.error.buttons.backToConnect}
              </Button>
            </StyledWithGap>
          </Column>
          <StyledColumn $span={6}>
            <img
              alt="Something went wrong illustration"
              src={`${window.config.storeblocksAssetsBaseUrl}/illustrations/something-went-wrong.svg`}
              height="500"
            />
          </StyledColumn>
        </StyledRow>
      </Page>
    </Center>
  );
};

const Center = styled.div`
  max-width: ${appConfig.maxPageWidth};
  margin: 0 auto;
`;

const Page = styled.div`
  margin-top: 72px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0 24px;
`;

const StyledRow = styled(Row)`
  margin-top: 8px;
`;

const StyledColumn = styled(Column)`
  display: flex;
  justify-content: center;
`;

const StyledWithGap = styled(WithGap)`
  align-items: start;
`;
